// Remove only the fields this builder auto-added from a subcategory workflow.
// Manually-added fields (no source: 'workflow') are left untouched.
export function stripWorkflowFields(fields) {
  return (fields || []).filter(field => field != null && field.source !== 'workflow');
}

// Return the candidate fields whose mapped_attribute is non-empty and not
// already present among existingFields or earlier candidates. Guards against
// duplicating an attribute the admin mapped manually. Order-preserving.
export function mergeFormFields(existingFields, candidateFields) {
  const taken = new Set(
    (existingFields || [])
      .map(field => field && field.mapped_attribute)
      .filter(Boolean)
  );
  const result = [];
  (candidateFields || []).forEach(field => {
    const mapped = field && field.mapped_attribute;
    if (!mapped || taken.has(mapped)) return;
    taken.add(mapped);
    result.push(field);
  });
  return result;
}
